/**
 * 搜尋區域組件
 * 處理搜尋輸入框和按鈕，開啟搜尋對話框
 */

import * as React from "react";
import { Button, Input, Label, makeStyles, tokens } from "@fluentui/react-components";
import { Search24Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  searchContainer: {
    display: "flex",
    gap: "8px",
    alignItems: "end",
    backgroundColor: tokens.colorNeutralBackground2,
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    flexShrink: 0,
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    flexGrow: 1,
  },
  label: {
    fontWeight: "600",
    fontSize: "13px",
    color: tokens.colorNeutralForeground2,
  },
  searchButton: {
    minWidth: "40px",
  },
});

const SearchSection = ({ searchQuery, onSearchQueryChange, onOpenSearchDialog }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.searchContainer}>
      <div className={styles.inputGroup}>
        <Label className={styles.label}>🔍 {t('search_label')}</Label>
        <div style={{ display: 'flex', gap: '6px' }}>
          <Input
            placeholder={t('search_placeholder')}
            value={searchQuery}
            onChange={(e, d) => onSearchQueryChange(d.value)}
            onKeyDown={(e) => e.key === 'Enter' && onOpenSearchDialog()}
            style={{ flex: 1 }}
          />
          <Button 
            icon={<Search24Regular />} 
            onClick={onOpenSearchDialog}
            appearance="primary"
            className={styles.searchButton}
          />
        </div>
      </div>
    </div>
  );
};

export default SearchSection;

